import { IControlOption } from '@/Interfaces/ControlOption.interface';
import AutocompleteControl from '@/components/Form/AutocompleteControl';
import { getFieldErrorProps } from '@/helpers/form';
import { useAppSelector } from '@/store/hooks';
import { selectClientsControlOptions } from '@/store/selectors/clients.selectors';
import { Button, InputLabel, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface IProps {
  openAdvertiserModal: () => void;
  removeControlOption: (value: IControlOption) => void;
}

const AgencyInfo = ({ openAdvertiserModal, removeControlOption }: IProps) => {
  const { control } = useFormContext();

  const { advertisers } = useAppSelector(selectClientsControlOptions);

  const onChangeListener = (reason: string, value?: IControlOption) => {
    if (reason === 'removeOption' && value) {
      removeControlOption(value);
    }
  };

  return (
    <>
      <div>
        <InputLabel htmlFor='name'>
          Name<span className='text-[#fe4033]'>*</span>
        </InputLabel>
        <Controller
          name='name'
          control={control}
          rules={{
            required: {
              value: true,
              message: 'Please enter name',
            },
          }}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              fullWidth
              placeholder='Enter Agency Name'
              id='name'
              {...getFieldErrorProps(fieldState)}
            />
          )}
        />
      </div>
      <div className='mt-4'>
        <InputLabel htmlFor='client'>Client</InputLabel>
        <Controller
          name='client'
          control={control}
          disabled
          render={({ field, fieldState }) => (
            <TextField {...field} fullWidth placeholder='Client' id='client' {...getFieldErrorProps(fieldState)} />
          )}
        />
      </div>
      <div className='mt-4'>
        <InputLabel htmlFor='advertisers'>Advertisers</InputLabel>
        <AutocompleteControl
          name='advertisers'
          id='advertisers-select'
          options={advertisers}
          control={control}
          placeholder='Select advertisers'
          multiple
          onChangeListener={onChangeListener}
        />
        <Button
          sx={{ height: 40, width: 200, marginTop: 2 }}
          color='primary'
          variant='contained'
          onClick={openAdvertiserModal}
        >
          + Create new Advertiser
        </Button>
      </div>
    </>
  );
};

export default AgencyInfo;
